export const createHashGenerator = () => {
  let index = 0;
  return () => {
    index += 1;
    return index;
  };
};
